<template>
  <v-container class="mt-8">

  	<v-row>
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-4">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Diplomas y certificaciones
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="actualizar_datos">
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="text-h6">
            Actualización de datos
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="alumno.nombre"
              label="Nombre"
              dense
              outlined
            ></v-text-field>

            <v-text-field
              v-model="alumno.apellido_paterno"
              label="Apellido paterno"
              dense
              outlined
            ></v-text-field>

            <v-text-field
              v-model="alumno.apellido_materno"
              label="Apellido materno"
              dense
              outlined
            ></v-text-field>

            <div>
              
              Recuerda, que el nombre que escribas, será el que aparecerá en tu certificado 
              <br/> 
              Es <strong>NECESARIO</strong> que tu nombre sea escrito con la primer letra en <strong>MAYÚSCULA</strong> y las demás en <strong>MINÚSCULA</strong>, ejemplo: 
              <br/>
              <strong>C</strong>arlos <strong>A</strong>lberto <strong>H</strong>ernández <strong>C</strong>astillo
  
              </div>

            <v-checkbox
              label="Acepto que son mis datos están correctos" 
              v-model="terminos"
              value="1"
              hide-details
            ></v-checkbox>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" class="mr-2" text>Cancelar</v-btn>
            <v-btn color="primary" @click="updateDatos()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" v-else>
        <v-row justify="center">
          <!-- Teens -->
          <v-col cols="9" sm="8" md="6" lg="4" v-if="escuela == 1">
            <v-card class="cert-card fill-height d-flex flex-column">
              <v-card-title class="cert-card__title justify-space-between pt-5">
                <span class="d-flex align-center">
                  Teens
                </span>
                <v-chip
                  small
                  :color="teens ? 'success' : 'grey lighten-1'"
                  :dark="!!teens"
                  class="font-weight-medium"
                >
                  {{ teens ? 'Disponible' : 'Bloqueado' }}
                </v-chip>
              </v-card-title>

              <v-card-text class="flex-grow-1 d-flex flex-column">
                <div class="cert-preview mb-4" :class="{ 'cert-preview--locked': !teens }">
                  <v-img
                    :src="teens
                      ? require('@/assets/certificados/teensbloqueado.jpg')
                      : require('@/assets/certificados/teensdesbloqueado.jpg')"
                    contain
                    max-height="220"
                    class="cert-preview__img"
                  ></v-img>
                  <div v-if="!teens" class="cert-preview__overlay">
                    <v-icon color="white" size="36">mdi-lock</v-icon>
                  </div>
                </div>

                <div v-if="tieneSolicitudTeens" class="cert-meta mb-3">
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Folio</span>
                    <span class="cert-meta__value">{{ solicitudTeens.idcertificado_fisico }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Nombre</span>
                    <span class="cert-meta__value">{{ solicitudTeens.nombre_completo }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Estatus</span>
                    <v-chip
                      small
                      dark
                      :color="colorEstatusFisico(solicitudTeens.estatus)"
                    >
                      {{ labelEstatusFisico(solicitudTeens.estatus) }}
                    </v-chip>
                  </div>
                </div>

                <v-alert
                  v-if="!teens"
                  dense
                  text
                  color="orange"
                  class="mb-0"
                >
                  <span class="text-caption">
                    Para poder habilitar esta opción, es necesario acreditar tus 16 niveles.
                  </span>
                </v-alert>
              </v-card-text>

              <v-card-actions class="px-4 pb-2 flex-column align-stretch">
                <v-btn
                  v-if="teens"
                  color="orange"
                  block
                  dark
                  rounded
                  elevation="0"
                  class="text-capitalize mb-2 mx-n2"
                  @click="generarCopiaCatorceNiveles(false)"
                >
                  Descargar copia
                </v-btn>
                <v-btn
                  v-if="!tieneSolicitudTeens && teens && !teens.grupo_online"
                  color="primary"
                  block
                  dark
                  rounded
                  elevation="0"
                  class="text-capitalize mx-n2"
                  @click="solicitarFisicoCatorceNiveles(0)"
                >
                  Solicitar fisico
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- Adultos / Finalizacion -->
          <v-col cols="9" md="6" lg="4">
            <v-card class="cert-card fill-height d-flex flex-column">
              <v-card-title class="cert-card__title justify-space-between pt-5">
                <span class="d-flex align-center">
                  Finalización
                </span>
                <v-chip
                  small
                  :color="adultos ? 'success' : 'grey lighten-1'"
                  :dark="!!adultos"
                  class="font-weight-medium"
                >
                  {{ adultos ? 'Disponible' : 'Bloqueado' }}
                </v-chip>
              </v-card-title>

              <v-card-text class="flex-grow-1 d-flex flex-column">
                <div class="cert-preview mb-4" :class="{ 'cert-preview--locked': !adultos }">
                  <v-img
                    v-if="escuela == 2"
                    :src="adultos
                      ? require('@/assets/certificados/nivel14Fast.jpg')
                      : require('@/assets/certificados/NonivelesFAST.jpg')"
                    contain
                    max-height="220"
                    class="cert-preview__img"
                  ></v-img>
                  <v-img
                    v-if="escuela == 1"
                    :src="adultos
                      ? require('@/assets/certificados/nivel14Inbi.jpg')
                      : require('@/assets/certificados/NonivelesInbi.jpg')"
                    contain
                    max-height="220"
                    class="cert-preview__img"
                  ></v-img>
                  <div v-if="!adultos" class="cert-preview__overlay">
                    <v-icon color="white" size="36">mdi-lock</v-icon>
                  </div>
                </div>

                <div v-if="tieneSolicitudAdultos" class="cert-meta mb-3">
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Folio</span>
                    <span class="cert-meta__value">{{ solicitudAdultos.idcertificado_fisico }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Nombre</span>
                    <span class="cert-meta__value">{{ solicitudAdultos.nombre_completo }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Estatus</span>
                    <v-chip
                      small
                      dark
                      :color="colorEstatusFisico(solicitudAdultos.estatus)"
                    >
                      {{ labelEstatusFisico(solicitudAdultos.estatus) }}
                    </v-chip>
                  </div>
                </div>

                <v-alert
                  v-if="!adultos"
                  dense
                  text
                  color="orange"
                  class="mb-0"
                >
                  <span class="text-caption">
                    Para poder habilitar esta opción, es necesario acreditar tus 14 niveles.
                  </span>
                </v-alert>
              </v-card-text>

              <v-card-actions class="px-6 flex-column align-stretch">
                <v-btn
                  v-if="adultos"
                  color="orange"
                  block
                  dark
                  rounded
                  elevation="0"
                  class="text-capitalize mb-2 mx-n2"
                  @click="generarCopiaCatorceNiveles(true)"
                >
                  Descargar copia
                </v-btn>
                <v-btn
                  v-if="!tieneSolicitudAdultos && adultos && !adultos.grupo_online"
                  color="primary"
                  block
                  rounded
                  elevation="0"
                  class="text-capitalize mx-n2"
                  @click="solicitarFisicoCatorceNiveles(1)"
                >
                  Solicitar fisico
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- Cambridge -->
          <v-col cols="9" sm="8" md="6" lg="4">
            <v-card class="cert-card fill-height d-flex flex-column">
              <v-card-title class="cert-card__title justify-space-between pt-5">
                <span class="d-flex align-center">
                  Cambridge
                </span>
                <v-chip
                  small
                  :color="certificado ? 'success' : 'grey lighten-1'"
                  :dark="!!certificado"
                  class="font-weight-medium"
                >
                  {{ certificado ? 'En proceso' : 'Sin registro' }}
                </v-chip>
              </v-card-title>

              <v-card-text class="flex-grow-1 d-flex flex-column">
                <div class="cert-preview mb-4">
                  <v-img
                    v-if="escuela == 2"
                    :src="certificado
                      ? require('@/assets/certificados/cambridgeFast.jpg')
                      : require('@/assets/certificados/plantilla_fast_B1.jpg')"
                    contain
                    max-height="220"
                    class="cert-preview__img"
                  ></v-img>
                  <v-img
                    v-if="escuela == 1"
                    :src="certificado
                      ? require('@/assets/certificados/cambridgeInbi.jpg')
                      : require('@/assets/certificados/plantilla_inbi_B1.jpg')"
                    contain
                    max-height="220"
                    class="cert-preview__img"
                  ></v-img>
                </div>

                <div
                  v-if="mostrarMetaCambridge"
                  class="cert-meta mb-3"
                >
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Folio</span>
                    <span class="cert-meta__value">{{ certificado.idcertificacion }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Nombre</span>
                    <span class="cert-meta__value">{{ certificado.nombre_completo }}</span>
                  </div>
                  <div class="cert-meta__row">
                    <span class="cert-meta__label">Estatus</span>
                    <v-chip
                      small
                      dark
                      :color="colorEstatusCambridge(certificado.estatus)"
                    >
                      {{ labelEstatusCambridge(certificado.estatus) }}
                    </v-chip>
                  </div>
                </div>

                <v-alert
                  v-if="puedeDescargarCambridge"
                  dense
                  text
                  color="success"
                  class="mb-2"
                >
                  <span class="text-caption">
                    ¡Felicidades! Concluiste tu certificación exitosamente. Ya puedes descargar tu certificado digital aquí mismo.
                  </span>
                </v-alert>

                <v-alert
                  v-if="certificado && ['A1','A2'].includes(certificado.nivel)"
                  dense
                  text
                  color="blue-grey"
                  class="mb-0"
                >
                  <span class="text-caption">
                    Finalizaste el proceso, pero el resultado no fue aprobatorio.
                    Contacta a tu asesor académico en un lapso no mayor a 24 horas
                    para la revalidación de certificación.
                  </span>
                </v-alert>

                <v-alert
                  v-if="pendienteEntrevistaCambridge"
                  dense
                  text
                  color="success"
                  class="mb-0"
                >
                  <span class="text-caption">
                    ¡Felicidades! Tu calificación es sobresaliente. Se requiere
                    una entrevista oral para liberar el certificado. Reportate
                    en un máximo de 24 horas con tu asesor académico.
                  </span>
                </v-alert>

                <v-alert
                  v-if="certificado && certificado.nivel == ''"
                  dense
                  text
                  color="info"
                  class="mb-0"
                >
                  <span class="text-caption">
                    Tu código ya fue asignado, pero aún no tenemos tu resultado.
                    Si ya lo contestaste, la actualización llegara en 2 días
                    o puedes levantar un ticket.
                  </span>
                </v-alert>
              </v-card-text>

              <v-card-actions class="px-4 pb-2 flex-column align-stretch">
                <v-btn
                  v-if="puedeDescargarCambridge"
                  color="orange"
                  block
                  dark
                  rounded
                  elevation="0"
                  class="text-capitalize mb-2 mx-n2"
                  @click="generarCopiaCambridge()"
                >
                  Descargar copia
                </v-btn>
                <v-btn
                  v-if="puedeSolicitarFisicoCambridge"
                  color="primary"
                  block
                  dark
                  rounded
                  elevation="0"
                  class="text-capitalize mx-n2"
                  @click="solicitarFisicoCambridge()"
                >
                  Solicitar fisico
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-speed-dial top fixed>
      <template v-slot:activator>
        <v-btn color="white" dark fab :to="{ name: 'Perfil' }">
          <v-icon color="primary">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader v-if="cargar" :loader="loader"/>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  const base64 = require('base-64');

  import Alerta from '@/components/alertas/Alerta.vue'
  import Loader from '@/components/alertas/Loader.vue'

  const ESTATUS_FISICO = {
    0: { label: 'Solicitado', color: 'blue darken-3' },
    1: { label: 'Creado', color: 'cyan darken-3' },
    2: { label: 'Enviado', color: 'teal accent-3' },
    3: { label: 'Recibido', color: 'orange darken-3' },
    4: { label: 'Entregado', color: 'green' },
  }

  const ESTATUS_CAMBRIDGE = {
    1: { label: 'En proceso', color: 'red' },
    2: { label: 'Generado', color: 'deep-purple darken-3' },
    3: { label: 'Solicitado', color: 'blue darken-3' },
    4: { label: 'Impreso', color: 'cyan darken-3' },
    5: { label: 'Enviado', color: 'teal accent-3' },
    6: { label: 'Recibido', color: 'orange darken-3' },
    7: { label: 'Entregado', color: 'green' },
  }

  export default {
    components: {
      Alerta,
      Loader
    },

    data: () => ({
      terminos: null,
      matricula: '',

      escuela: 0,
      actualizar_datos: false,
      alumno: null,

      diploma_catorce_niveles: false,
      boton14Niveles: true,
      solicitudNiveles: false,
      sin_datos_niveles: false,
      bloqueadoFisicoCatorce: false,

      diplomas_certificaciones: false,
      botonCertificacion: true,
      datos_certificado_cambridge: null,
      sin_datos_cambridge: false,
      bloqueadoFisicoCambridge: false,

      noPasa: false,

      respuestaAlerta: false,
      loader: true,
      cargar: false,
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },

      sinResultadoCambridge: false,

      mostrarCertificacion: false,
      teens: false,
      solicitudAdultos: null,
      solicitudTeens: null,
      adultos: null,
      certificado: null,
    }),

    computed: {
      ...mapGetters('login', ['getGrupo', 'getUsuarioLMS']),

      // B1/B2 siempre; C1/C2 solo si entrevista_ok = 1 (aprobación en recepción)
      puedeDescargarCambridge () {
        if (!this.certificado || !this.certificado.nivel) return false
        const nivel = String(this.certificado.nivel).trim()
        if (['B1', 'B2'].includes(nivel)) return true
        if (['C1', 'C2'].includes(nivel) && Number(this.certificado.entrevista_ok) === 1) return true
        return false
      },

      pendienteEntrevistaCambridge () {
        if (!this.certificado) return false
        const nivel = String(this.certificado.nivel || '').trim()
        return ['C1', 'C2'].includes(nivel) && Number(this.certificado.entrevista_ok) !== 1
      },

      mostrarMetaCambridge () {
        if (!this.puedeDescargarCambridge || !this.certificado) return false
        const nivel = String(this.certificado.nivel || '').trim()
        if (['C1', 'C2'].includes(nivel)) return Number(this.certificado.entrevista_ok) === 1
        return Number(this.certificado.estatus) > 0
      },

      puedeSolicitarFisicoCambridge () {
        if (!this.certificado) return false
        const nivel = String(this.certificado.nivel || '').trim()
        return ['B1', 'B2'].includes(nivel) && Number(this.certificado.estatus) === 0
      },

      tieneSolicitudAdultos () {
        return !!(this.solicitudAdultos && this.solicitudAdultos.idcertificado_fisico)
      },

      tieneSolicitudTeens () {
        return !!(this.solicitudTeens && this.solicitudTeens.idcertificado_fisico)
      },
    },

    async created() {
      this.initialize()
    },

    methods: {
      labelEstatusFisico(estatus) {
        return (ESTATUS_FISICO[estatus] || {}).label || 'Desconocido'
      },

      colorEstatusFisico(estatus) {
        return (ESTATUS_FISICO[estatus] || {}).color || 'grey'
      },

      labelEstatusCambridge(estatus) {
        return (ESTATUS_CAMBRIDGE[estatus] || {}).label || 'Desconocido'
      },

      colorEstatusCambridge(estatus) {
        return (ESTATUS_CAMBRIDGE[estatus] || {}).color || 'grey'
      },

      initialize() {
        this.cargar = true
        const id_alumno = base64.encode(String(this.getUsuarioLMS.id))
        return this.$http.post('academico.alumno.buscar/' + id_alumno).then(response => {
          this.cargar = false
          this.escuela = response.body.escuela

          if (response.body.estatus == 0) {
            this.alumno = response.body.usuario
            this.actualizar_datos = true
          } else {
            this.teens = response.body.teens || null
            this.adultos = response.body.adultos || null
            // Normalizar para que el v-if no falle con objetos vacios / undefined
            const solAdultos = response.body.solicitudAdultos
            const solTeens = response.body.solicitudTeens
            this.solicitudAdultos = (solAdultos && solAdultos.idcertificado_fisico) ? solAdultos : null
            this.solicitudTeens = (solTeens && solTeens.idcertificado_fisico) ? solTeens : null
            this.mostrarCertificacion = response.body.mostrarCertificacion
            this.certificado = response.body.certificado || null
          }
          this.overlay = false
        }).catch(error => {
          this.validarError(error)
        }).finally(() => { this.cargar = false })
      },

      validarError(value) {
        this.cargar = false
        if (value.status == 400 || value.status == 500) {
          this.parametros.mensaje = value.body.message
          this.parametros.dialogError = true
          this.parametros.color = '#FF2C2C'
          this.respuestaAlerta = true
        }
      },

      errorNombreUsuario() {
        this.cargar = false
        this.parametros.mensaje = 'Lo sentimos, pero tu nombre no cuenta con los criterios adecuados, por favor revisa los criterios para poder continuar'
        this.parametros.dialogError = true
        this.parametros.color = '#FF2C2C'
        this.respuestaAlerta = true
      },

      updateDatos() {
        if (!this.terminos) {
          this.parametros.mensaje = 'Para continuar, es necesario aceptar que tus datos est\u00e1n correctos'
          this.parametros.dialogError = true
          this.parametros.color = '#FF2C2C'
          this.respuestaAlerta = true
          return
        }

        let letraAnterior = 'a'
        var letras_mayusculas = ['A','B','C','D','E','F','G','H','Y','J','K','L','M','N','\u00D1','O','P','Q','R','S','T','U','V','W','X','Y','Z'];

        for (const i in this.alumno.nombre) {
          if (letras_mayusculas.includes(this.alumno.nombre[i]) && letras_mayusculas.includes(letraAnterior)) {
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.nombre[i]
        }

        letraAnterior = 'a'
        for (const i in this.alumno.apellido_paterno) {
          if (letras_mayusculas.includes(this.alumno.apellido_paterno[i]) && letras_mayusculas.includes(letraAnterior)) {
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.apellido_paterno[i]
        }

        letraAnterior = 'a'
        for (const i in this.alumno.apellido_materno) {
          if (letras_mayusculas.includes(this.alumno.apellido_materno[i]) && letras_mayusculas.includes(letraAnterior)) {
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.apellido_materno[i]
        }

        this.alumno.datos_actualizados = 1
        this.cargar = true

        this.$http.post('academico.alumno.update', this.alumno).then(() => {
          this.cargar = false
          this.actualizar_datos = false
          this.initialize()
        }).catch(error => {
          this.validarError(error)
        }).finally(() => { this.cargar = false })
      },

      async generarCopiaCatorceNiveles(adultos) {
        this.cargar = true
        this.getUsuarioLMS['adultos'] = adultos
        this.$http.post('academico.copia.niveles/' + this.escuela, this.getUsuarioLMS).then(response => {
          window.open(this.$http.options.root + 'copias-certificados/' + response.body.nombreArchivo);
          this.cargar = false
        }).catch(error => {
          this.validarError(error)
        }).finally(() => { this.cargar = false })
      },

      async solicitarFisicoCatorceNiveles(adultos) {
        this.cargar = true

        let payload = {
          iderp: this.getUsuarioLMS.iderp,
          nombre_completo: this.getUsuarioLMS.nombre + ' ' + this.getUsuarioLMS.apellido_paterno + ' ' + this.getUsuarioLMS.apellido_materno,
          usuario_registro: this.getUsuarioLMS.iderp,
          estatus: 0,
          url: '',
          deleted: 0,
          unidad_negocio: this.escuela,
          adultos: adultos ? 1 : 0
        }

        try {
          const response = await this.$http.post('academico.solicitar.certificado', payload)
          this.actualizar_datos = false
          this.diplomas_certificaciones = false
          this.diploma_catorce_niveles = false
          // Si el API ya trae la solicitud, pintarla de inmediato
          if (response.body && response.body.solicitud && response.body.solicitud.idcertificado_fisico) {
            if (adultos) this.solicitudAdultos = response.body.solicitud
            else this.solicitudTeens = response.body.solicitud
          }
          await this.initialize()
          this.parametros.mensaje = (response.body && response.body.message) || 'Solicitud generada correctamente'
          this.parametros.dialogError = true
          this.parametros.color = 'success'
          this.respuestaAlerta = true
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async solicitarFisicoCambridge() {
        this.cargar = true

        let payload = {
          idcertificacion: this.certificado.idcertificacion,
          idusuario: this.getUsuarioLMS.id,
          nombre_completo: this.getUsuarioLMS.nombre + ' ' + this.getUsuarioLMS.apellido_paterno + ' ' + this.getUsuarioLMS.apellido_materno,
          estatus: 1
        }

        this.$http.put('academico.certificacion.update', payload).then(() => {
          this.dialogSuccess = true
          this.actualizar_datos = false
          this.diplomas_certificaciones = true
          this.diploma_catorce_niveles = false
          this.initialize()
          this.cargar = false
        }).catch(error => {
          this.validarError(error)
        }).finally(() => { this.cargar = false })
      },

      async generarCopiaCambridge() {
        this.cargar = true
        this.$http.post('academico.copia.cambridge/' + this.escuela, this.certificado).then(response => {
          console.log(response.body.nombreArchivo)
          window.open(this.$http.options.root + 'copias-certificados/' + response.body.nombreArchivo);
          this.cargar = false
        }).catch(error => {
          this.validarError(error)
        }).finally(() => { this.cargar = false })
      },

      limpiar() {
        this.alumno = null
        this.diploma_catorce_niveles = false
        this.diplomas_certificaciones = false
        this.actualizar_datos = false
        this.boton14Niveles = true
        this.solicitudNiveles = false
        this.certificado = null
        this.botonCertificacion = true
        this.sin_datos_niveles = false
        this.sin_datos_cambridge = false
      }
    },
  }
</script>

<style scoped>
  .certificados-page {
    max-width: 1200px;
  }

  .page-header__icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #006093 0%, #1a8fc4 100%);
    box-shadow: 0 8px 20px rgba(0, 96, 147, 0.28);
  }

  .page-header__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #006093;
    letter-spacing: -0.02em;
  }

  .page-header__subtitle {
    font-size: 0.9rem;
    color: #78909c;
  }

  .cert-card {
    border-radius: 18px !important;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08) !important;
    overflow: visible;
    background: #ffffff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .cert-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12) !important;
  }

  .cert-card__title {
    font-size: 1.05rem !important;
    font-weight: 600 !important;
    color: #37474f;
    word-break: normal;
  }

  .cert-preview {
    position: relative;
    background: #f5f8fb;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
  }

  .cert-preview__img {
    border-radius: 8px;
    overflow: hidden;
  }

  .cert-preview--locked .cert-preview__img {
    filter: grayscale(0.35) brightness(0.92);
  }

  .cert-preview__overlay {
    position: absolute;
    inset: 12px;
    border-radius: 8px;
    background: rgba(38, 50, 56, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cert-meta {
    background: #f7fafc;
    border-radius: 12px;
    padding: 10px 14px;
  }

  .cert-meta__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
  }

  .cert-meta__row + .cert-meta__row {
    border-top: 1px solid #e8eef3;
  }

  .cert-meta__label {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #90a4ae;
    font-weight: 600;
    flex-shrink: 0;
  }

  .cert-meta__value {
    font-size: 0.875rem;
    color: #455a64;
    font-weight: 500;
    text-align: right;
  }

  .name-hint {
    background: #f0f7fb !important;
  }

  .colorCurso {
    color: #006093;
  }
</style>
